export default "__VITE_ASSET__66d472c4__"